import axios from 'axios'
import apiConfig from '../apiConfig'

const {
  getTcinInfo,
  generateShotSheets,
  generateContactSheets,
  generateContactSheetsFinal,
  generateContactSheetsStores,
  generateCompactShotSheets,
  getUserCustomColumns,
} = apiConfig

export function expandRelationshipService(request, accessToken) {
  return axios.post(getTcinInfo, request, {
    params: {
      key: apiConfig.apiKey,
    },
    headers: { Authorization: accessToken },
  })
}

export const generatePDFAPIService = (tcins, accessToken, progressCallBack) => {
  const url = `${generateShotSheets}`
  return axios.post(
    url,
    { tcins: tcins },
    {
      params: {
        key: apiConfig.apiKey,
      },
      headers: { Authorization: accessToken },
      responseType: 'blob',
      onDownloadProgress(progressEvent) {
        let length = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('Content-Length')
        let percentCompleted = Math.round((progressEvent.loaded * 100) / length)
        progressCallBack(percentCompleted)
      },
    },
    {}
  )
}

export const getTcinDataService = (studio = '', request, accessToken) => {
  const url = `${getTcinInfo}`
  return axios.post(url, request, {
    params: {
      key: apiConfig.apiKey,
      // studio,  // removed studio based filters for now as per request, can be added back if needed in future
    },
    headers: { Authorization: accessToken },
  })
}

export const generateContactSheetPDFAPIService = (
  tcins,
  accessToken,
  progressCallBack
) => {
  const url = `${generateContactSheets}`
  return axios.post(
    url,
    { tcins: tcins },
    {
      params: {
        key: apiConfig.apiKey,
      },
      headers: { Authorization: accessToken },
      responseType: 'blob',
      onDownloadProgress(progressEvent) {
        let length = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('Content-Length')
        let percentCompleted = Math.round((progressEvent.loaded * 100) / length)
        progressCallBack(percentCompleted)
      },
    },
    {}
  )
}

export const generateContactSheetFinalPDFAPIService = (
  tcins,
  accessToken,
  progressCallBack,
  dpci
) => {
  const url = `${generateContactSheetsFinal}`
  return axios.post(
    url,
    { tcins: tcins, dpci: dpci },
    {
      params: {
        key: apiConfig.apiKey,
      },
      headers: { Authorization: accessToken },
      responseType: 'blob',
      onDownloadProgress(progressEvent) {
        let length = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('Content-Length')
        let percentCompleted = Math.round((progressEvent.loaded * 100) / length)
        progressCallBack(percentCompleted)
      },
    },
    {}
  )
}

export const generateContactSheetStoresPDFAPIService = (
  dpci,
  accessToken,
  progressCallBack
) => {
  const url = `${generateContactSheetsStores}`
  return axios.post(
    url,
    { dpci: dpci },
    {
      params: {
        key: apiConfig.apiKey,
      },
      headers: { Authorization: accessToken },
      responseType: 'blob',
      onDownloadProgress(progressEvent) {
        let length = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('Content-Length')
        let percentCompleted = Math.round((progressEvent.loaded * 100) / length)
        progressCallBack(percentCompleted)
      },
    },
    {}
  )
}

export const generateCompactShotSheetPDFAPIService = (
  tcins,
  accessToken,
  progressCallBack
) => {
  const url = `${generateCompactShotSheets}`
  return axios.post(
    url,
    { tcins: tcins },
    {
      params: {
        key: apiConfig.apiKey,
      },
      headers: { Authorization: accessToken },
      responseType: 'blob',
      onDownloadProgress(progressEvent) {
        let length = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('Content-Length')
        let percentCompleted = Math.round((progressEvent.loaded * 100) / length)
        progressCallBack(percentCompleted)
      },
    },
    {}
  )
}

export const setSaveUserColumnsService = (request, accessToken) => {
  return axios.post(`${getUserCustomColumns}?view=tcin`, request, {
    params: {
      key: apiConfig.apiKey,
    },
    headers: { Authorization: accessToken },
  })
}

export const getUserViewDataService = (lanId) => {
  return axios.get(
    `${getUserCustomColumns}?user_id=${lanId.toUpperCase()}&view=tcin`,
    {
      params: {
        key: apiConfig.apiKey,
      },
    }
  )
}
